module.exports = __webpack_public_path__ + "img/Tokyo-02.9a1ac903.jpg";